<template>
  <div class="link">
    <header>
      <div class="title">相关链接</div>
    </header>
    <div class="headerBlk"></div>
    <div class="container lkbox">
      <div class="lk">
        <a class="clwebsite" href="http://tw.cljewels.com/" target="_blank">
          <img data-v-56b687e3="" src="@/assets/img/chiilih.svg" alt="">
        </a>
        <a class="wc" href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzUyMjM2OTU4OA==&scene=124&#wechat_redirect" target="_blank">
          <img data-v-56b687e3="" src="@/assets/img/wc.png" alt="">
        </a>
        <!-- <a class="wb" target="_blank">
          <img data-v-56b687e3="" src="@/assets/img/wb.png" alt="">
        </a> -->
        <!-- <a class="wb" href="https://www.weibo.com/rbqili?refer_flag=1001030101_&is_hot=1" target="_blank">
          <img data-v-56b687e3="" src="@/assets/img/wb.png" alt="">
        </a> -->
      </div>
      <!-- <div class="row">
        <img width="100%" src="@/../static/img/group.svg" alt="">
      </div> -->
    </div>
    <div class="navsBlk"></div>
  </div>
</template>

<script>
import navs from '@/components/nav'
export default {
  name: 'Links',
  components: {
    navs
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App',
      articles: ''
    }
  },
  created() {
    // this.$store.state.player.playerDisplay = false
    this.$store.state.player.ize = false
    $(window).scrollTop(0)
  },
  methods: {
    fetchArticles: function() {
      axios.get('static/item.json').then(
        response => {
          this.articles = response.data
        },
        error => {
          console.log(error)
        }
      )
    }
  },
  computed: {
    // ...mapGetters(['idNb', 'playUrls', 'imgUrl', 'voiceName'])
  },
  mounted() {
    // $('.ssd').html('SSSSDDDDDrrrrrr')
    // var array = [1]
    // var other = _.concat(array, 2, [3], [[4]])
    // console.log(other)
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/ly.scss';

.lkbox {
  display: flex;
  align-content: center;
  display: block;
  position: relative;
  // height: 100vh;
  .lk {
    width: 100%;
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    & > a {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 90px;
      margin: 60px 30px;
      text-align: center;
      img{
        height: 100px;
      }
      &::after {
        position: relative;
        bottom: 0px;
        width: 100%;
        padding: 18px;
        color: $gol-lig;
      }
    }
    .clwebsite {
      width: 100%;
      img {
        // height: 100px;
        width: 100%;
      }
      &::after {
        content: '官方網站';
      }
    }
    .wc {
      // width: 40%;
      img {
        height: 120px;
      }
      &::after {
        content: '微信公众号';
      }
    }
    .wb {
      // width: 40%;
      img {
        // width: 100%;
      }
      &::after {
        content: '微博';
      }
    }
  }
}

.voicelist {
  padding: 0;
  margin: 0;
  li {
    padding: 0;
    margin: 0;
    display: inline-flex;
    // justify-content: center;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #ccc;
    img {
      height: 58px;
      margin: 8px;
    }
    .name {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/link.vue